/**
 * @module app.shared
 */

/**
 * Generate a max decimal number for a desired number of digits and precision
 */
export function maxDecimal(digits: number, precision: number): number {
    return Math.min(
        Number(`${'9'.repeat(digits - precision)}.${'9'.repeat(Math.min(15 - digits + precision, precision))}`),
        Number.MAX_SAFE_INTEGER
    );
}
